<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card flat class="rounded-lg primary--text mt-3 px-md-2">
          <v-row align="center">
            <v-col cols="1" class="text-start ps-7">
              <div class="d-flex align-center">
                <v-checkbox
                  :input-value="isAllSelected"
                  @change="updateSelection(dataList, $event)"
                  :disabled="!dataList || !dataList.length"
                />

                {{ $t("all") }}
              </div>
            </v-col>

            <v-col cols="3" class="text-start">
              {{ $t("reports.employee") }}
            </v-col>

            <v-col cols="3" class="text-start">
              {{ $t("user.civilIdOrPassport") }}
            </v-col>

            <v-col cols="3" class="text-start">
              {{ $t("user.email") }}
            </v-col>

            <v-col cols="2" class="text-start">
              {{ $t("user.registration.registrationStatus") }}
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row v-if="!loading && dataList.length">
          <v-col cols="12" v-for="(data, index) in dataList" :key="index">
            <AttendanceDownloadCard
              :data="data"
              :isSelected="haveSelected(data)"
              @onChange="value => updateSelection([data], value)"
            />
          </v-col>
        </v-row>

        <v-row
          v-else-if="!loading && !dataList.length"
          class="textLight--text font-weight-medium my-16"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>

        <v-row v-else-if="loading && !dataList.length" class="my-16">
          <v-col cols="12">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>

        <v-row justify="end" v-if="dataList && dataList.length">
          <v-col cols="12" sm="6">
            <v-combobox
              hide-details
              append-icon=""
              ref="remarksComboBox"
              :height="100"
              :label="$t('user.registration.remarks')"
              flat
              solo
              v-model="remarks"
              :items="remarksArr"
              outlined
              class="rounded-lg"
            >
              <template v-slot:item="{ item }">
                <div class="d-flex justify-start">
                  {{ item }}
                </div>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="dataList && dataList.length">
            <div class="d-flex justify-end">
              <BulkDownloadButton
                :selections="selections"
                :downloading="downloading"
                @onClear="selections = []"
                @onClick="bulkDownload"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import BulkDownloadButton from "@/app/core-module/components/BulkDownloadButton";
import AttendanceDownloadCard from "./AttendanceDownloadCard.vue";

import { bulkDownloadAttendanceSheets } from "@/app/user-module/helpers/attendenceSheetHelper";
export default {
  components: {
    BulkDownloadButton,
    AttendanceDownloadCard,
  },
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    batch: null,
    organization: {
      type: String,
      default: "",
    },
    training: {
      type: String,
      default: "",
    },
    trainer: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: true,
    },
    remarksArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selections: [],
      downloading: false,
      subscriberInfo: null,
      remarks: null,
    };
  },
  computed: {
    isAllSelected() {
      return (
        this.selections?.length &&
        this.dataList?.length &&
        this.dataList?.every(x => this.haveSelected(x))
      );
    },
  },
  apollo: {
    getSubscriberProfile() {
      return {
        query: require("../api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.subscriberInfo = data.getSubscriberProfile;
          }
        },
      };
    },
  },
  methods: {
    haveSelected(obj) {
      return this.selections?.findIndex(x => x._id === obj._id) >= 0;
    },
    updateSelection(list, isSelected) {
      list.forEach(obj => {
        const existingIndex = this.selections.findIndex(x => x._id === obj._id);

        if (isSelected) {
          if (existingIndex < 0) {
            this.selections.push(obj);
          }
        } else {
          if (existingIndex >= 0) {
            this.selections.splice(existingIndex, 1);
          }
        }
      });
    },
    async bulkDownload() {
      await this.$refs["remarksComboBox"].blur();
      this.downloading = true;

      this.downloadAttendancePdf().then(response => {
        if (response) {
          this.selections = [];
          this.remarks = null;
        }

        this.downloading = false;
      });
    },
    downloadAttendancePdf() {
      let batchNumber = "",
        courseTitle = this.training ? this.training : "",
        date = this.date
          ? this.$moment(this.date, "YYYY-MM-DD").format("DD MMM YYYY")
          : "",
        trainer = this.trainer ? this.trainer : "",
        company = this.organization ? this.organization : "";

      if (this.batch) {
        batchNumber = this.batch.UID ?? "";

        courseTitle = this.getLocalisedValue(this.batch.trainingTitle, {
          preferredLocale: "en",
        });

        date = this.batch.startDate
          ? this.$moment(parseInt(this.batch.startDate)).format("DD MMM YYYY")
          : "";

        trainer = this.batch.trainerName ?? "";

        company = this.getLocalisedValue(this.batch.organizationName, {
          preferredLocale: "en",
        });
      } else if (this.selections?.length) {
        batchNumber = this.selections[0].batchNumber ?? "";
      }

      let data = [
        {
          subscriberInfo: this.subscriberInfo,
          batchNumber,
          courseTitle,
          date,
          trainer,
          company,
          remarks: this.remarks ? this.remarks : "",
          employees: this.selections?.length
            ? this.selections.map(obj => {
                let newObj = {};

                newObj.firstName = `${obj?.employee?.user?.firstName || ""} ${
                  obj?.employee?.user?.lastName || ""
                }`;
                newObj.email = obj?.employee?.user?.email
                  ? obj.employee.user.email
                  : "";
                newObj.civilIdOrPassport = obj?.employee?.user
                  ?.civilIdOrPassport
                  ? obj.employee.user.civilIdOrPassport
                  : "";
                newObj.designation = obj?.employee?.designation
                  ? obj.employee.designation
                  : "";

                return newObj;
              })
            : [],
        },
      ];

      return bulkDownloadAttendanceSheets({
        attendanceSheets: data,
      });
    },
  },
};
</script>
